import React, { useState } from 'react';
import { GlassCard } from '../components/ui/GlassCard';
import { NeonButton } from '../components/ui/NeonButton';
import { DumbbellIcon } from '../components/Icons';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

type AuthView = 'landing' | 'login' | 'register';

export default function AuthLanding() {
  const [view, setView] = useState<AuthView>('landing');

  if (view === 'login') {
    return <LoginForm onBack={() => setView('landing')} />;
  }

  if (view === 'register') {
    return <RegisterForm onBack={() => setView('landing')} />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <GlassCard className="p-10 text-center max-w-lg w-full">
        <div className="flex justify-center mb-6">
          <DumbbellIcon className="text-cyan-400 h-16 w-16 -rotate-45" />
        </div>

        <h1 className="text-4xl font-bold text-white mb-2">
          AETHER<span className="text-cyan-400">FIT</span>
        </h1>

        <p className="text-cyan-400/80 mb-8 text-lg">
          AI-Powered Fitness Platform
        </p>

        <div className="space-y-4">
          <NeonButton
            onClick={() => setView('register')}
            className="w-full py-4 text-lg"
          >
            Create Account
          </NeonButton>

          <button
            onClick={() => setView('login')}
            className="w-full py-3 text-gray-400 hover:text-white transition-colors"
          >
            Already have an account? <span className="text-cyan-400">Sign In</span>
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-cyan-300/20">
          <p className="text-sm text-gray-500">
            Connect with personal trainers • Track your progress • AI-powered coaching
          </p>
        </div>
      </GlassCard>
    </div>
  );
}
